export default __webpack_public_path__ + "static/media/mark.17f38eca.svg";